export const datasetshare = {
	// states
	'accessType_OWNER': 'Owner',
	'accessType_WRITE': 'Writer',
	'accessType_READ': 'Reader',

	'share with people': 'Share your dataset with people by entering their email',
}
export default datasetshare;
